'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _axios = require('axios');

var _requestQueue = require('./requestQueue');

var _requestQueue2 = _interopRequireDefault(_requestQueue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GigwalkAxios = function (_Axios) {
    (0, _inherits3.default)(GigwalkAxios, _Axios);

    function GigwalkAxios() {
        var defaultConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, _classCallCheck3.default)(this, GigwalkAxios);

        var adapter = void 0;

        // Copied from axios/core/dispatchRequest.js
        if (typeof XMLHttpRequest !== 'undefined') {
            // For browsers use XHR adapter
            adapter = require('axios/lib/adapters/xhr'); // eslint-disable-line global-require
        } else if (typeof process !== 'undefined') {
            // For node use HTTP adapter
            adapter = require('axios/lib/adapters/http'); // eslint-disable-line global-require
        }

        var requestQueue = new _requestQueue2.default(adapter);

        // FlowIssue - Can't suppress this error because it generates an error on line 0 of this file
        // See https://github.com/facebook/flow/issues/2167. Using destructuring on types
        // that implement an interface doesn't work with properties that are maybe types
        /*
        const config: $AxiosXHRConfigBase<*> = {
            baseURL: 'https://api.app.gigwalk.com',
            ...defaultConfig,
             // Use a custom adapter which adds the request to a RequestQueue
            adapter(requestConfig: $AxiosXHRConfig<any>): Promise<$AxiosXHR<any>> {
                return requestQueue.add(requestConfig);
            }
        };
        */

        var config = {};
        config.baseURL = defaultConfig.baseURL ? defaultConfig.baseURL : 'https://api.app.gigwalk.com';
        config.adapter = function (requestConfig) {
            return requestQueue.add(requestConfig);
        };

        // Note: To pass type checking, manual assignment of maybe types is required. See above FlowIssue
        if (defaultConfig.auth) config.auth = defaultConfig.auth;
        if (defaultConfig.progress) config.progress = defaultConfig.progress;
        if (defaultConfig.maxContentLength) config.maxContentLength = defaultConfig.maxContentLength;
        if (defaultConfig.maxRedirects) config.maxRedirects = defaultConfig.maxRedirects;
        if (defaultConfig.headers) config.headers = defaultConfig.headers;
        if (defaultConfig.params) config.params = defaultConfig.params;
        if (defaultConfig.paramsSerializer) config.paramsSerializer = defaultConfig.paramsSerializer;
        if (defaultConfig.responseType) config.responseType = defaultConfig.responseType;
        if (defaultConfig.transformResponse) config.transformResponse = defaultConfig.transformResponse;
        if (defaultConfig.transformRequest) config.transformRequest = defaultConfig.transformRequest;
        if (defaultConfig.timeout) config.timeout = defaultConfig.timeout;
        if (defaultConfig.validateStatus) config.validateStatus = defaultConfig.validateStatus;
        if (defaultConfig.withCredentials) config.withCredentials = defaultConfig.withCredentials;
        if (defaultConfig.xsrfCookieName) config.xsrfCookieName = defaultConfig.xsrfCookieName;
        if (defaultConfig.xsrfHeaderName) config.xsrfHeaderName = defaultConfig.xsrfHeaderName;
        if (defaultConfig.httpAgent) config.httpAgent = defaultConfig.httpAgent;
        if (defaultConfig.httpsAgent) config.httpsAgent = defaultConfig.httpsAgent;

        return (0, _possibleConstructorReturn3.default)(this, (GigwalkAxios.__proto__ || (0, _getPrototypeOf2.default)(GigwalkAxios)).call(this, config));
    }

    return GigwalkAxios;
}(_axios.Axios);

exports.default = GigwalkAxios;
//# sourceMappingURL=client.js.map